import { tracking } from '@iwoca/frontend-tracking-library';

import { TrackingSource } from '../trackingSource';
import { ModalStep } from '../useBankSelectionFlow';

// Not exported: knip fails CI on exports no other file imports.
type StepProperties = { step: ModalStep; source: TrackingSource };
type DismissMethod = 'not_now' | 'modal_close';
type DismissedProperties = StepProperties & { method: DismissMethod };
type ExtendOutcome = 'extended' | 'reauth_required' | 'failed';
type RevokeOutcome = 'revoked' | 'cancelled' | 'closed' | 'failed';
type ClickedProperties = { bank_name?: string; connection_count: number };
// The outcome property is named per journey: a bare `outcome` is deleted in the
// Amplitude tracking plan, so anything sent under it is unusable.
type ExtendOutcomeProperties = {
    ob_extend_outcome: ExtendOutcome;
    bank_name?: string;
};
type RevokeOutcomeProperties = {
    ob_revoke_outcome: RevokeOutcome;
    bank_name?: string;
};

// Excludes 'reconsentLoading' — a spinner, not a screen. Add new reconsent
// screens here to count them.
const TRACKED_STEPS: ModalStep[] = [
    'reconfirmConsent',
    'reconfirm',
    'reauth',
    'confirmRevoke',
    'extendSuccess',
    'revokeSuccess',
    'reconsentError'
];

export const isTrackedStep = (step: ModalStep) => TRACKED_STEPS.includes(step);

const ABANDONABLE_STEPS: ModalStep[] = [
    'reconfirmConsent',
    'reconfirm',
    'reauth',
    'confirmRevoke',
    'reconsentError'
];

export const isAbandonableStep = (step: ModalStep) =>
    ABANDONABLE_STEPS.includes(step);

// ampli types these properties as bare strings; the wrappers hold the unions.
export const trackStepViewed = (p: StepProperties) =>
    tracking.ampli.openBankingReconsentStepViewed(p);

export const trackDismissed = (p: DismissedProperties) =>
    tracking.ampli.openBankingReconsentDismissed(p);

export const trackExtendClicked = (p: ClickedProperties) =>
    tracking.ampli.openBankingReconsentExtendClicked(p);

export const trackExtendOutcome = (p: ExtendOutcomeProperties) =>
    tracking.ampli.openBankingReconsentExtendOutcome(p);

export const trackReauthRedirected = (p: { bank_name?: string }) =>
    tracking.ampli.openBankingReconsentReauthRedirected(p);

export const trackRevokeClicked = (p: ClickedProperties) =>
    tracking.ampli.openBankingReconsentRevokeClicked(p);

export const trackRevokeOutcome = (p: RevokeOutcomeProperties) =>
    tracking.ampli.openBankingReconsentRevokeOutcome(p);
